import { createClient, type SupabaseClient } from '@supabase/supabase-js'

import { config } from '@/app/config'

import type { Database } from './database.types'

export type CentimeClient = SupabaseClient<Database>

/**
 * Client Supabase unique de l'application.
 * Les règles d'accès sont portées par la Row Level Security de Postgres, jamais par le client.
 */
export const supabase: CentimeClient = createClient<Database>(
  config.supabase.url,
  config.supabase.publishableKey,
  {
    auth: {
      flowType: 'pkce',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'centime.auth',
    },
    global: {
      headers: { 'x-client-info': `centime-web/${config.environment}` },
    },
  },
)
